import React, { ForwardedRef } from "react";

import { forwardRef } from "react";
import {
  TextField,
  InputAdornment,
  InputProps,
  TextFieldProps,
  Typography,
  Stack,
} from "@mui/material";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

// Datepicker
import ReactDatePicker, { ReactDatePickerProps } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import InfoMsg from "./InfoMsg";

export type DatePickerProps = ReactDatePickerProps & {
  label: string;
  info?: string;
  color?:
    | "primary"
    | "info"
    | "error"
    | "secondary"
    | "success"
    | "warning"
    | undefined;
  variant?: "outlined" | "filled" | "standard" | undefined;
  size?: "small" | "medium" | undefined;
  fullWidth?: boolean;
  inputProps?: InputProps;
};

type CalendarInputProps = TextFieldProps & {
  info?: string;
};

const CalendarInput = forwardRef(
  (
    {
      onChange,
      placeholder,
      value,
      onClick,
      error,
      helperText,
      label,
      info,
      required,
      color,
      size,
      inputProps,
      fullWidth,
      variant,
    }: CalendarInputProps,
    ref
  ) => (
    <>
      <Stack direction="row">
        <Typography
          component="span"
          variant="subtitle2"
          className={`${required ? "field-required" : ""}`}
        >
          {label}
        </Typography>
        {info && <InfoMsg info={info} />}
      </Stack>
      <TextField
        ref={ref as ForwardedRef<HTMLDivElement>}
        inputProps={inputProps}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <div onClick={onClick} style={{ cursor: "pointer" }}>
                <CalendarMonthIcon />
              </div>
            </InputAdornment>
          ),
        }}
        variant={variant}
        fullWidth={fullWidth}
        size={size}
        color={color}
        error={error}
        helperText={helperText}
        onChange={onChange}
        placeholder={placeholder}
        value={value}
      />
    </>
  )
);

const CustomDatePicker = (props: DatePickerProps) => {
  const {
    label,
    info,
    color = "primary",
    size = "small",
    inputProps = {},
    fullWidth = true,
    variant = "outlined",
    minDate,
    ...otherProps
  } = props;

  return (
    <ReactDatePicker
      dateFormat="dd/MM/yyyy"
      {...otherProps}
      minDate={minDate}
      customInput={
        <CalendarInput
          label={label}
          color={color}
          size={size}
          InputProps={inputProps}
          fullWidth={fullWidth}
          variant={variant}
          info={info}
        />
      }
    />
  );
};

export default CustomDatePicker;
